/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Faq_A3Inputs */

const en_dr_faq_a3 = /** @type {(inputs: Dr_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesian or English, per room — the AI facilitator, the session report and the handoff into the PRD all follow the room's chosen language.`)
};

const id_dr_faq_a3 = /** @type {(inputs: Dr_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia atau Inggris, per ruang — fasilitator AI, laporan sesi, dan hasil serah-terima ke PRD mengikuti bahasa yang dipilih ruang tersebut.`)
};

/**
* | output |
* | --- |
* | "Indonesian or English, per room — the AI facilitator, the session report and the handoff into the PRD all follow the room's chosen language." |
*
* @param {Dr_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_faq_a3 = /** @type {((inputs?: Dr_Faq_A3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Faq_A3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_faq_a3(inputs)
	return en_dr_faq_a3(inputs)
});